export const GET_PARENT_CHAT_LIST = "GET_PARENT_CHAT_LIST";
export const GET_PARENT_SINGLE_CHAT_VIEW = "GET_PARENT_SINGLE_CHAT_VIEW";
export const SEND_PARENT_CHAT = "SEND_PARENT_CHAT";
